import React from 'react';
import styled from 'styled-components';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	icon: React.ReactNode;
}

interface IconButtonState {}

export class IconButton extends React.Component<IconButtonProps, IconButtonState> {
	constructor(props: IconButtonProps) {
		super(props);

		this.state = {};
	}

	render() {
		const { children, ...props } = this.props;

		return (
			<button {...props}>
				<Container>
					{this.props.icon}
					<span>{children && children}</span>
				</Container>
			</button>
		);
	}
}

const Container = styled.div`
	display: flex;
	justify-content: center;
	justify-items: center;
	align-items: center;
`;
